import { cloneDeep, flow, partial } from "lodash";

import { AttributeTypes } from "../../../../../../constants";
import { SpaceComponentObject } from "../../../../../../types";
import commonComponentReducer from "../../../../SpaceConfig/SpaceConfigContext/useSpaceConfig/reducer/componentReducer";
import {
  SpaceConfigAction,
  BaseComponentConfigState,
  ComponentConfigState
} from "../../../../types";
import { DefaultValueType } from "../../../constants";
import inputReducer from "../../common/inputReducer";
import { getCommonInputProperties } from "../../common/util";
import { SpaceFilePickerProperties } from "../../SpaceFilePicker/types";
import { hasInputComponentProperties } from "../../util/util";
import { SpaceJsonInputComponent } from "../types";

export interface JsonInputConfigState
  extends BaseComponentConfigState<SpaceJsonInputComponent> {
  type: "JSON_INPUT";
}

export const INITIAL_STATE = {
  type: "JSON_INPUT" as const,
  draftComponent: {} as SpaceJsonInputComponent
};

function isJsonInputConfigState(
  state: ComponentConfigState
): state is JsonInputConfigState {
  return state.type === "JSON_INPUT";
}

export const getComponentProperties = (
  properties: Partial<SpaceFilePickerProperties>
) => ({
  ...properties,
  ...getCommonInputProperties(
    properties,
    DefaultValueType.JSON_VALUE,
    "",
    AttributeTypes.JSON,
    true
  )
});

export function ensureJsonInputConfigState(
  state: ComponentConfigState
): JsonInputConfigState {
  if (isJsonInputConfigState(state)) return state;

  throw new Error("Expected JsonInput config state.");
}

export function ensureSpaceJsonInputComponent(
  component: SpaceComponentObject
): SpaceJsonInputComponent {
  if (
    !!component.type &&
    typeof component.properties.placeholder === "string" &&
    hasInputComponentProperties(component)
  ) {
    return component;
  }

  return {
    ...component,
    properties: getComponentProperties(component.properties)
  };
}

export function makeInitialState(
  draftComponent: SpaceComponentObject
): JsonInputConfigState {
  return {
    ...INITIAL_STATE,
    draftComponent: ensureSpaceJsonInputComponent(cloneDeep(draftComponent))
  };
}

export default (state: JsonInputConfigState, action: SpaceConfigAction) =>
  flow([commonComponentReducer, partial(inputReducer, partial.placeholder, action)])(
    state,
    action
  );
